export default __webpack_public_path__ + "static/icon-benefits-home-calendario-951228c973ec7c704c4de3ced3c573fc.png";